import { useState, useEffect } from 'react';
import { getHeadersUnwrapped, searchUserByLastName, useUserContext } from '..';
import { compose as lcompose } from 'lodash/fp';

export const useLastNameSearch = () => {
  const { user } = useUserContext();

  const [input, setInput] = useState('');
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    lcompose(
      searchUserByLastName,
      getHeadersUnwrapped
    )(user)(input).then(setOptions);
  }, [input, user]);

  return {
    users: options,
    lastNameSearchInput: input,
    setLastNameSearchInput: setInput,
  };
};
